export default __webpack_public_path__ + "static/media/kitchen3-afterC.f2886ebc.jpg";